export class ProductInfoModel{ 
       public Type: string;
       public Brand:string;
       public Model:string;
       public Price:string
}

export interface IModel{ 
    Id: string,
    Value: string,
    TypeId:string,
    BrandId: string,
    FullProduct: string
    Price: number
}
  
  